<template>
  <section class="newCard-container cursor-pointer" :style="`background-image: url(${newCard.image})`">
    <div class="newCard-action-layer" @click="action" :style="{ bottom: newCard.activity.property.useLivePreview ? '30%' : '0' }"></div>
    <img v-if="!showVideoPreview && !showFeedPreview" class="newCard-image" :style="imageStyle" :src="newCard.image" />
    <!-- <VideoPlayer class="newCard-videoplayer" :product="newCard" :src="newCard.srcVideo" :autoplay="true" v-if="showVideoPreview && !showFeedPreview"></VideoPlayer> -->
    <iframe class="newCard-videoplayer" :src="newCard.srcVideo" frameborder="0" allow="autoplay" v-if="showVideoPreview && !showFeedPreview"></iframe>
    <Feed class="newCard-feed" :activityID="newCard.target" :useAsWidget="true" v-if="showFeedPreview"></Feed>
    <div class="newCard-details" :style="conferenceCardDetailsStyle" v-if="true">
      <div class="newCard-name-container">
        <div class="newCard-name" v-html="localizedName"></div>
      </div>
      <p class="newCard-description" :style="descriptionStyle" v-html="localizedDescription" v-if="localizedDescription?.length > 0"></p>
    </div>
  </section>
</template>

<script>
import api from '@/services/api.js';
import SpinnerButton from '@/components/ui/SpinnerButton.vue';
import VideoPlayer from '@/components/general/VideoPlayer.vue';
import Feed from '@/components/user_content/Feed.vue';

export default {
  name: 'NewCard',
  components: { SpinnerButton, VideoPlayer, Feed },

  props: {
    newCard: {},
    imageStyle: {},
    conferenceCardDetailsStyle: {},
    roleStyle: {},
    descriptionStyle: {},
  },
  data() {
    return {
      activityData: { property: { stream: '' } },
      showVideoPreview: false,
      showFeedPreview: false,
      isNew: true,
      userProfile: null,
      playProfileNotification: false,
      updaterInterval: null,
      actionKey: '',
      cardLoaded: false,
    };
  },

  computed: {
    localized() {
      return this.newCard.activity?.property?.localized || {};
    },
    localizedContent() {
      const currentLocale = this.$i18n.locale || 'pt';
      return this.localized[currentLocale];
    },
    localizedName() {
      if (this.localizedContent?.name) return this.localizedContent.name;
      else return this.newCard.name || this.newCard.activity?.name || '';
    },
    localizedDescription() {
      if (this.localizedContent?.description) return this.localizedContent.description;
      else return this.newCard.description || this.newCard.activity?.description || '';
    },
  },

  methods: {
    loadCardActivity() {
      this.activityData = { ...this.activityData, ...this.newCard.activity };
      this.cardLoaded = true;
    },
    async handleActivityPreview() {
      try {
        const activity = this.newCard.activity;
        if (!activity) return;

        const parseProperty = (prop) => {
          if (typeof prop === 'string') {
            try {
              return JSON.parse(prop);
            } catch (e) {
              console.error('[NewCard] Failed to parse activity.property:', prop, e);
              return {};
            }
          }
          return prop || {};
        };

        if (this.newCard.url === 'Live') {
          const parsed = parseProperty(activity.property);
          if (parsed.srcVideo && this.newCard.activity?.property?.useLivePreview) {
            this.$set(this.newCard, 'srcVideo', `${parsed.srcVideo}&autoplay=1&muted=1`);
            this.showVideoPreview = true;
          }
        } else if (this.newCard.url === 'Timeline') {
          this.showVideoPreview = false;
          this.showFeedPreview = true;
        }
      } catch (err) {
        console.error('[NewCard] Error fetching activities or processing live/Rede Social preview:', err);
      }
    },
    action() {
      const act = this.newCard.actionType;
      if (act === 'router') {
        if (this.newCard.url === 'Explorer') {
         // console.log('Navigating to Explorer with stream:', this.newCard.target, 'and panel:', this.newCard.panel);
          let panel = this.newCard.panel;
          this.$router.push({
            name: 'Explorer',
            params: { stream: this.newCard.target },
            query: { panel: panel },
          });
        } else {
          this.$router
            .push({
              name: this.newCard.url,
              params: {
                stream: this.newCard.target,
              },
            })
            .catch((err) => {
              console.error('navigation error', err);
            });
        }
      } else if (act == 'conference') {
        if (typeof this.activityData.property.meetLink === 'string' && this.activityData.property.meetLink.startsWith('{')) {
          try {
            if (this.activityData.property.openLinkInNewTab) {
              const obj = JSON.parse(this.activityData.property.meetLink);
              let routeData = this.$router.resolve({ name: obj.name, params: { stream: obj.params.stream } });
              window.open(routeData.href, '_blank');
            } else this.$router.push(JSON.parse(this.activityData.property.meetLink));
          } catch (err) {
            console.error(err);
          }
        } else if (this.$store.state.template.useZoomIntegration && this.newCard.url.includes('zoom')) this.$router.push({ name: 'Conference', params: { stream: this.activityData.activity_id } });
        else window.open(this.activityData.property.meetLink);
      } else if (act == 'card-router') {
        if (typeof this.activityData.property.meetLink == 'string' && this.activityData.property.meetLink.startsWith('http')) {
          if (this.activityData.property.openLinkInNewTab) window.open(this.activityData.property.meetLink, '_blank');
          else window.open(this.activityData.property.meetLink, '_parent');
        } else {
          try {
            const route = JSON.parse(this.activityData.property.meetLink);
            if (this.activityData.property.openLinkInNewTab) {
              let routeData = this.$router.resolve({
                name: route.name,
                params: route.name === 'Schedule' ? { date_start: route.params.date_start ?? null } : { stream: route.params.stream },
              });
              window.open(routeData.href, '_blank');
            } else {
              this.$router
                .push({
                  name: route.name,
                  params: route.name === 'Schedule' ? { date_start: route.params.date_start ?? null } : { stream: route.params.stream },
                })
                .catch((err) => {
                  console.error('navigation error', err);
                });
            }
          } catch (err) {
            console.error('navigation error', err);
          }
        }
      } else if (act == 'link') {
        window.open(this.newCard.url, this.newCard.target);
      } else if (act == 'inscript') {
        api
          .post(`activity/${this.newCard.target}/inscript`)
          .then((response) => {
            if (response.data) {
            }
          })
          .catch((err) => {
            console.error(err);
          });
      } else if (act == 'talk') {
        api
          .post(`event/${this.$store.state.eventId}/createTalkChannel`, {
            user_id: this.newCard.target,
            channelName: this.newCard.url,
          })
          .then((response) => {
            if (response.data) {
              this.$router
                .push({
                  name: 'Messages',
                  params: {
                    channelId: response.data.talk_channel_id,
                  },
                })
                .catch((err) => {
                  console.error('navigation error', err);
                });
            }
          })
          .catch((err) => {
            console.error(err);
          });
      } else if (act == 'none') {
      } else {
      }
      this.$emit('finished');
      api.post(`sessionAction/`, {
        action: 'Card Action',
        properties: JSON.stringify({ route: this.$route.name, params: this.$route.params, card: this.newCard }),
        userid: this.$store.state.user.id,
        sessionid: this.$store.state.user.token,
        event_id: this.$store.state.eventId,
      });
    },
    // videoPreview method removed; logic now in beforeMount
    isLive(item) {
      if (item.date_start) {
        let startDate = new Date(item.date_start);
        let finishDate = new Date(item.date_finish);
        let today = new Date();

        return Date.parse(startDate) < Date.parse(today) && Date.parse(finishDate) > Date.parse(today);
      } else return true;
    },
    apiGetSchedule(isReload) {
      api
        .get(`event/${this.$store.state.eventId}/schedule?user_id=${this.$store.state.user.id}`)
        .then((response) => {
          let resp = response.data;
          let filtered = resp.filter((schedule) => {
            return schedule.activity_id == this.activityData.activity_id;
          });
          this.isNew = filtered.length == 0;

          this.$nextTick(() => {
            this.cardLoaded = true;
          });
        })
        .catch((err) => {
          console.error(err);
        });
    },

    apiPostSchedule(item) {
      this.playProfileNotification = false;
      this.$emit('playProfileNotification', this.playProfileNotification);

      let payload = {
        event_id: this.$store.state.eventId,
        user_id: this.$store.state.user.id,
        activity_id: this.activityData.activity_id,
        start_date: new Date(this.activityData.date_start),
        finish_date: new Date(this.activityData.date_finish),
        title: this.activityData.description_short,
        description: this.activityData.description,
        notes: '',
        config: JSON.stringify({
          group: this.activityData.trail ? this.activityData.trail : this.activityData.category,
          image: item.image,
          class: 'card',
          draggable: true,
        }),
        links: item.target ? item.target : '',
        guests: JSON.stringify([]),
        organizer: this.$store.state.user.id,
        status: 'Confirmado',
        confirm: JSON.stringify(false),
        public: JSON.stringify(false),
      };

      api
        .get(`event/${this.$store.state.eventId}/schedule`)
        .then((response) => {
          let isNew = response.data.filter((schedule) => schedule.activity_id == payload.activity_id).length == 0;

          if (isNew) {
            api
              .post(`event/${this.$store.state.eventId}/schedule/`, payload)
              .then((response) => {
                this.playProfileNotification = true;
                this.$emit('playProfileNotification', this.playProfileNotification);

                setTimeout(() => {
                  this.playProfileNotification = false;

                  this.$emit('playProfileNotification', this.playProfileNotification);
                }, 3000);

                this.loadCardActivity();
              })
              .catch((err) => {
                this.playProfileNotification = false;
                this.$emit('playProfileNotification', this.playProfileNotification);
                console.error(err);
              });
          } else return;
        })
        .catch((err) => console.error(err));
    },
    goToPersonalSchedule() {
      this.$router.push({ name: 'PersonalSchedule' });
    },
  },

  async beforeMount() {
    this.actionKey = this.$RNG.randomID();
    this.userProfile = this.$store.state.template.userProfile;

    this.loadCardActivity();
    await this.handleActivityPreview();
  },

  mounted() {
    this.updaterInterval = setInterval(() => {
      this.actionKey = this.$RNG.randomID();
    }, 10000);
  },
  beforeDestroy() {
    clearInterval(this.updaterInterval);
  },
};
</script>

<style scoped lang="scss">
.newCard-container {
  position: relative;
  min-height: 260px;
  height: 100%;
  width: 100%;

  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;

  justify-self: flex-start;
  display: flex;
  flex-direction: column;
  background-color: var(--card-bgColor);
  border-radius: var(--card-borderRadius);
  box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.2);
  transition: 0.3s;

  @include media('<=phone') {
    min-height: 58vw;
  }
}

.newCard-action-layer {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
  border-radius: var(--card-borderRadius);
}

.newCard-image {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  z-index: 0;

  display: block;
  height: 100%;
  object-fit: cover;
  object-position: center;
  border-radius: var(--card-borderRadius);
  transition: opacity 0.3s ease-in-out;
}

.newCard-videoplayer {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  backdrop-filter: blur(5px);

  display: block;
  height: 100%;
  object-fit: cover;
  object-position: center;
  border-radius: var(--card-borderRadius);
}

.newCard-feed {
  position: absolute;
  top: 0;
  right: 13px;
  bottom: 0;
  left: -10px;
  z-index: 0;
  overflow-y: auto;

  display: block;
  height: 100%;

  @include media('<=phone') {
    right: 0px;
    left: 0px;
  }
}

.newCard-details {
  position: relative;
  padding: 12px;
  height: 100%;
  z-index: 1;
  color: var(--card-textColor, rgba(233, 233, 233, 0.945));
  pointer-events: none;

  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}
.newCard-name-container {
  position: relative;
  display: flex;
  height: auto;
}
.newCard-name {
  position: relative;
  // font-size: var(--card-titleFontSize);
  font-weight: 700;
  width: 100%;

  text-shadow: 2px 2px 1px rgba(0, 0, 0, 0.1); //, -1px -1px 2px rgba(255, 255, 255, 0.3);
  //filter: drop-shadow(0 0 3px rgba(0, 0, 0, 0.3));
}
.newCard-description {
  position: relative;
  // font-size: var(--card-descriptionFontSize);
  max-height: 200px;
  overflow-y: auto;
  word-wrap: break-word;

  //text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.3), -1px -1px 2px rgba(255, 255, 255, 0.3);
  //filter: drop-shadow(0 0 3px rgba(0, 0, 0, 0.3));

  &::-webkit-scrollbar {
    background-color: transparent;
    width: 0px;
  }
  &::-webkit-scrollbar-track {
    background-color: var(--card-scrollbarBgColor);
    border-radius: var(--card-scrollbarBorderRadius);
  }
  &::-webkit-scrollbar-thumb {
    background-color: var(--card-scrollbarHandleColor) !important;
    border-radius: var(--card-scrollbarBorderRadius);
    background-image: none !important;
  }
}

.newCard-button-disabled {
  position: relative;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bolder;
  position: relative;
  background-color: transparent;
  color: var(--card-buttonBgColor);
  border: 1px solid var(--card-buttonBgColor);
  border-radius: var(--card-buttonBorderRadius);
  margin: 0 10px;
}
.newCard-noURL {
  position: relative;
  cursor: auto;
  pointer-events: none;
}
</style>
